import {h} from 'preact'
import {AppPage} from '../_common/components/app-page'
import {C, F, FR} from '../_common/layout'
import {t} from '../_i18n'
import './secretary-styles.scss'
import {ButtonPrimary} from '../_common/components/buttons/buttons'
import {useHistory} from 'react-router'
import {useDispatch, useSelector} from "react-redux";
import {Select} from '../_common/forms/components/components'
import {useEffect, useState} from "preact/hooks";
import {
    createCertificateCart,
    fetchCertificateTypes,
    purchasedDocuments,
    certificatesControllerGetPrestaCertificates
} from "../_rx/certificates/actions";
import {Fragment} from "react";
import Modal from "../_common/components/Modal/index";
import {isSpanishUser} from "../_common/utils/getLang";

export default function RequestCertificate() {
    /** Variables **/
    const history = useHistory();
    const enrolledAcademicPrograms = useSelector(state => (state.status.student_meta.enrolled_academic_programs));
    const academicPrograms = enrolledAcademicPrograms.filter(ap => ap.formative_zone);
    const certificates = useSelector(state => state.certificates?.types?.filter(type => type?.id_attribute !== "191")) || [];
    const prestaCertificates = useSelector(state => state.certificates?.prestaCertificates);
    const purchasedCertificates = useSelector(state => (state.certificates.purchasedCertificates));
    const dispatch = useDispatch();
    const studentId = useSelector(state => state.auth.loggedUser.id);
    const spanishUser = useSelector(state => (isSpanishUser(state.status.student_meta.shop_id)));

    /** State **/
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [selectedCertificate, setSelectedCertificate] = useState(null);
    const [certificateImage, setCertificateImage] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);

    /** Lifecycle **/
    useEffect(() => {
        dispatch(fetchCertificateTypes());
        if (enrolledAcademicPrograms.length > 0) {
            enrolledAcademicPrograms.filter(ap => ap.formative_zone).forEach(async (program) => {
                dispatch(purchasedDocuments(studentId, program.id));
            });
        }
    }, [dispatch, studentId, enrolledAcademicPrograms, selectedCourse]);

    useEffect(() => {
        if (academicPrograms.length) {
            academicPrograms?.forEach((program) => {
                dispatch(certificatesControllerGetPrestaCertificates(program.id));
            })
            if(!selectedCourse) setSelectedCourse(Number(academicPrograms[0]?.id));
        }
    }, academicPrograms)

    useEffect(() => {
        if (certificates.length && !selectedCertificate) {
            setSelectedCertificate(Number(certificates[0]?.id_product_attribute));
        }
    }, certificates)

    useEffect(() => {
        if (prestaCertificates && selectedCourse && selectedCertificate) {
            setCertificateImage(prestaCertificates[selectedCourse]
                ?.find(course => Number(course.id_product_attribute) === selectedCertificate)
                ?.image || null)
        }
    }, [prestaCertificates, selectedCourse, selectedCertificate])

    /**  Methods **/
    const handleCourseSelect = (e) => {
        setSelectedCourse(Number(e.target.value));
    }

    const handleCertSelect = (e) => {
        setSelectedCertificate(Number(e.target.value));
    }

    async function clickButton() {
        if (loading) return;

        try {
            setLoading(true);

            const course = selectedCourse || academicPrograms[0].id;
            const certificate = selectedCertificate || certificates[0].id_product_attribute;

            dispatch(createCertificateCart(course, certificate));

        } catch (e) {
            setLoading(false);
        }
    }

    /** Render **/
    return certificates && (
        <AppPage title={t('Certificados')} back={history.goBack} className="max-width-980">
            {purchasedCertificates && Object.values(purchasedCertificates).some(certificate => certificate.length !== 0) &&
                <F className="max-width-980">
                    <C className="purchased-certificates">
                        <h1>Solicitados</h1>
                        {academicPrograms.length > 0 && academicPrograms.map(program => {
                            const certsForProgram = purchasedCertificates[program.id];
                            return (
                                <div key={program.id} className="m-bottom m-x2-top">
                                    {certsForProgram && certsForProgram.length > 0 ? (
                                        <Fragment>
                                            <h4>{program.title}</h4>
                                            {certsForProgram.map(cert => (
                                                    <p>
                                                        <a key={cert.download_link}
                                                           className='txt-color-primary font-bold t-underline'
                                                           href={cert.download_link} target="_blank" rel="noopener noreferrer">
                                                            {cert.certificate_code}
                                                        </a>
                                                    </p>
                                                ))}
                                        </Fragment>
                                    ) : ''}
                                </div>
                            );
                        })}
                    </C>
                </F>
            }
            <F className="max-width-980 m-x2-top">
                <C>
                    <h1 className="mb-4">{t('Solicitar Certificado')}</h1>
                    <p className="mb-4">{t('Puedes solicitar un certificado seleccionando el tipo de certificado y abonando la tasa correspondiente. Entre 5 y 7 días hábiles recibirás el certificado en tu correo electrónico.')}</p>
                    {spanishUser && <p class="alert alert-info"><b>IMPORTANTE:</b> En caso de solicitar un certificado de notas para presentarlo ante las Administraciones de la <b>Comunidad Valenciana</b> o <b>Galicia</b>, debes contactar con Secretaría Académica e indicárselo una vez realizado el pago.</p>}
                    <div className="m-top-x2">
                        {academicPrograms.length > 1 && <div className="max-width-580 m-top-x1">
                            <span>{t('Ciclo:')}</span>
                            <Select onChange={handleCourseSelect} noEmptyOption={true}
                                    options={academicPrograms.map((element, index) => ({
                                        key: element.id,
                                        id: index,
                                        name: element.title
                                    }))} required/>
                        </div>}
                        <div class="d-flex flex-bottom">
                            <div className="max-width-580 m-top">
                                <span>{t('Certificado')}:</span>
                                <Select onChange={handleCertSelect} noEmptyOption={true}
                                    options={certificates.map(element => ({
                                        key: element.id_product_attribute,
                                        id: element.id_product_attribute,
                                        name: element.name
                                    }))} required />
                            </div>
                            {certificateImage &&
                                <div className="d-flex m-l">
                                    <i
                                        className="far fa-info-circle info-icon"
                                        onClick={() => setShowModal(true)}
                                        title="Ver ejemplo de certificado"
                                    />
                                    {showModal && (
                                        <Modal visible={showModal} closeModal={() => setShowModal(false)}>
                                            <div className="certificate-modal-container">
                                                <FR className="modal-title-padding row-2-el p-all p-x2-left p-x2-right">
                                                    <div className="col-80">
                                                        <p className="t-left font-18 no-margin">
                                                            {certificates?.find(certificate => Number(certificate.id_product_attribute) === selectedCertificate).name}
                                                        </p>
                                                    </div>
                                                    <div className="t-right col-20">
                                                        <a
                                                            onClick={() => setShowModal(false)}
                                                            className="modal-close-jobs modal-link"
                                                        >
                                                            <i className="fal fa-times font-20" />
                                                        </a>
                                                    </div>
                                                </FR>
                                                <hr className="separator-xxs no-margin-top no-margin-bottom" />
                                                <div className="certificate-modal-body">
                                                    <img
                                                        src={certificateImage}
                                                        alt="Certificado"
                                                        className="certificate-modal-img"
                                                    />
                                                </div>
                                            </div>
                                        </Modal>
                                    )}
                                </div>
                            }
                        </div>
                    </div>

                    <div className="m-top-x2">
                        <ButtonPrimary
                            className='btn-inverse'
                            onClick={clickButton}
                            disabled={loading}
                        >
                            {loading ? t('Enviando solicitud...') : t('Realizar pago')}
                        </ButtonPrimary>
                    </div>
                </C>
            </F>
        </AppPage>
    )
}
